import React from "react";
import ComparisonReport from "../comparison/ComparisonReport";
import FCRBubbleChart from "../dashboard/fcrBubbleChart";
import { useTranslation } from 'react-i18next';

const FCRComparison = () => {
  const { t } = useTranslation(['common', 'analytics']);
  return (
  <ComparisonReport
    title={t('analytics:compare.fcrReport')}
    renderChart={(data, { mode, isLoading }) => (
      <FCRBubbleChart
        data={data}
        title={t('analytics:compare.fcrTitle')}
        id={Math.random()}
        loading={isLoading}
        mode={mode}
      />
    )}
  />
  );
};

export default FCRComparison;
